import AuthGuard from './auth/auth-guard';

/**
 * Enregistre la websocket de notification et branche la récupération de session.
 *
 * - L'URL est fournie par un provider (getter) relu à chaque reconnexion,
 *   pour toujours utiliser le token JWT courant.
 * - Sur erreur d'authentification (fermeture 4001), on tente un refresh du JWT
 *   puis une reconnexion ; si le refresh échoue ou boucle, on redirige vers login.
 * - Si la reconnexion réseau est épuisée, on redirige vers login.
 */
export function registerNotificationWs(app, notificationWs) {
    const MAX_AUTH_RETRIES = 2;
    let authRetries = 0;

    const urlProvider = () => notificationWs.url;

    // Un message reçu prouve que la session est valide : on réarme le compteur.
    app.onWsMessage(notificationWs.name, () => { authRetries = 0; });

    app.onWsMessage(`${notificationWs.name}:auth-error`, async () => {
        if (authRetries >= MAX_AUTH_RETRIES) {
            AuthGuard.redirectToLogin();
            return;
        }

        authRetries += 1;

        if (await AuthGuard.isAuthenticated()) {
            app.registerWs(notificationWs.name, urlProvider);
        } else {
            AuthGuard.redirectToLogin();
        }
    });

    app.onWsMessage(`${notificationWs.name}:reconnect-failed`, () => {
        AuthGuard.redirectToLogin();
    });

    app.registerWs(notificationWs.name, urlProvider);
}

export default registerNotificationWs;
